var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWatermarkDesktop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1440 1086",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_83_1793)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.445 1363.49H440.494L727.236 1076.84L1014.16 1364H1329.38L726.73 761.345L127.445 1363.49Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1329.38 -277.493H1016.33L729.589 9.15634L442.702 -278H127.445L730.095 324.655L1329.38 -277.493Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1540.49 988.63V827.152L1253.93 540.322L1541 253.346V94.4746L1383.95 95.1623L938.53 540.828L1383.84 984.286L1540.49 988.63Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-100.493 94.4746V255.989L186.068 542.819L-101 829.795V988.63L56.0857 987.978L501.469 542.312L56.1581 98.8545L-100.493 94.4746Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_83_1793"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1642,
    height: 1642,
    fill: "white",
    transform: "translate(-101 -278)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatermarkDesktop);
export default __webpack_public_path__ + "static/media/watermark-desktop.88f02c41767001f7887e8c0c28f49c42.svg";
export { ForwardRef as ReactComponent };